import { Injectable } from '@angular/core';
import { AES, enc, mode, pad } from 'crypto-js';
import * as CryptoTS from 'crypto-js';
@Injectable({
  providedIn: 'root'
})
export class AesEncriptionDecriptionService {

  secretKey: string = "TechsolCPrL@2021_qI8ZVm8PqH";
  constructor() { }
  appProperties = {
    VALUES: {
      KEY: "TechsolCPrL@2021_qI8ZVm8PqH",
      IV: "TechsolCPrL@2024"
    }
  }

  // encrypt(value: string): any {
  //   var inputValue = enc.Utf8.parse(value.toString());
  //   var key = enc.Utf8.parse(this.secretKey);
  //   var iv = enc.Utf8.parse(this.secretKey);
  //   var encryptedString = AES.encrypt(inputValue, key,
  //     {
  //       keySize: 128 / 8,
  //       iv: iv,
  //       mode: mode.CBC,
  //       padding: pad.Pkcs7
  //     });
  //   debugger;
  //   return encryptedString.toString();
  // }

  // decrypt(textToDecrypt: any) {
  //   var key = enc.Utf8.parse(this.secretKey);
  //   var iv = enc.Utf8.parse(this.secretKey);
  //   var decryptedString = AES.decrypt(textToDecrypt, key,
  //     {
  //       keySize: 128 / 8,
  //       iv: iv,
  //       mode: mode.CBC,
  //       padding: pad.Pkcs7
  //     });

  //   return decryptedString.toString(enc.Utf8);
  // }

  encryptionAES(msg) {
    if (msg) {
      try {
        const ciphertext = CryptoTS.AES.encrypt(msg, this.secretKey, this.appProperties);
        return ciphertext.toString();
      }
      catch (ex) {
      }

    } else {
      return null;
    }

  }

  decryptionAES(msg) {
    if (msg) {
      try {
        const bytes = CryptoTS.AES.decrypt(msg, this.secretKey, this.appProperties);
        const plaintext = bytes.toString(CryptoTS.enc.Utf8);
        return plaintext;
      }
      catch (ex) {
      }
    }
    else {
      return null;
    }

  }

}
